import React from 'react'
import { FilterItem } from './FilterItem'
import { useIsTablet } from '../useIsTablet'
import AnimateHeight from 'react-animate-height'
import { useTranslation } from 'utils/useTranslation'

export function FilterInner({
  showFilters,
  showModels,
  productCount,
  modelsCounts,
  modelSet,
  setModelSet,
  isModelFilterOpen,
  setIsModelFilterOpen,
  categoriesCounts,
  categorySet,
  setCategorySet,
  isCategoryFilterOpen,
  setIsCategoryFilterOpen,
  setPage,
  whiteBackground = false
}) {
  const isTablet = useIsTablet()
  const accessoryStrings = useTranslation('accessories_shop.misc') ?? {}
  const hasModelOptions = Array.isArray(modelsCounts) && modelsCounts.length > 0
  const hasCategoryOptions = Array.isArray(categoriesCounts) && categoriesCounts.length > 0

  const handleModelClick = (set) => {
    setPage(1)
    setModelSet(set)
  }
  const handleCategoryClick = (set) => {
    setPage(1)
    setCategorySet(set)
  }

  const filterInnerMarkup = () => {
    return (
      <div className='mtt-filter__inner'>
        {showModels && hasModelOptions ? (
          <FilterItem
            label={accessoryStrings.model}
            optionsCount={modelsCounts}
            value={modelSet}
            onChange={handleModelClick}
            isPopoverOpen={isModelFilterOpen}
            setIsPopoverOpen={setIsModelFilterOpen}
            productCount={productCount}
            whiteBackground={whiteBackground}
            isModels={showModels}
          />
        ) : null}
        {hasCategoryOptions && (
          <FilterItem
            label={accessoryStrings.category}
            optionsCount={categoriesCounts}
            value={categorySet}
            onChange={handleCategoryClick}
            isPopoverOpen={isCategoryFilterOpen}
            setIsPopoverOpen={setIsCategoryFilterOpen}
            productCount={productCount}
            whiteBackground={whiteBackground}
          />
        )}
      </div>
    )
  }

  if (
    (showModels && !hasModelOptions && !hasCategoryOptions) || // This is configurator accessory shop
    (!showModels && !hasCategoryOptions) // This is standalone accessory shop
  ) {
    return null
  }

  if (isTablet) {
    return (
      <AnimateHeight duration={500} height={showFilters ? 'auto' : 0}>
        {filterInnerMarkup()}
      </AnimateHeight>
    )
  }

  return filterInnerMarkup()
}
